/*
  Sélecteur de formule — bêta « abonnement 1 an inclus » (Piano LED).

  Comment ça s'intègre à w-ATC-PRODUCT-PL.js sans le modifier :
  - Prix : le script de la section calcule tous les prix affichés (bouton, en-tête, barre fixe, Klarna)
    à partir de data-variant-price sur les cartes couleur. On y met « prix couleur + prix abonnement »
    quand Virtuoso est choisi, puis on relance son change() : tous les prix suivent, y compris sa
    protection qui réapplique le prix toutes les 50 ms.
  - Panier : on intercepte l'envoi des formulaires d'ajout (principal et barre fixe) et on ajoute en un
    seul appel /cart/add.js le Piano LED Plus (+ l'abonnement pour Virtuoso), puis on émet les mêmes
    événements (variant:add, cart:change) que la section pour que le panier latéral se mette à jour et
    s'ouvre. La ligne du Piano LED Plus porte la formule (_formule) et son nom complet (_formule_nom,
    ex. « Piano LED Plus Virtuoso ») que le panier latéral affiche à la place du nom du produit.
  - Packs (piano + Piano LED Plus, sections/w-ATC-PRODUCT-PIANO-PACK.liquid, data-pl-formula-mode="pack") :
    la page charge aussi w-ATC-PRODUCT-PL.js. Packs à une option (couleur) : même principe que ci-dessus.
    Packs piano + couleur : la section lit ses prix dans [data-variants-json] (lu une fois) et les protège toutes
    les 50 ms ; on enveloppe donc sa méthode updatePianoPackVariantSelection pour lui donner « prix du pack
    + abonnement » quand Virtuoso est choisi, puis on la relance. Prix barré Virtuoso = prix barré du pack
    (ou son prix) + prix barré de l'abonnement. Pas de _formule_nom : le panier garde le nom du pack.
*/
(function () {
  'use strict';

  var MAIN_PROP = '_formule';
  var ADDON_PROP = '_inclus_avec';
  var NAME_PROP = '_formule_nom';

  function formatMoney(cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(precision, thousands, decimal) {
      var fixed = value.toFixed(precision).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return fixed[1] ? whole + decimal + fixed[1] : whole;
    }
    var amount = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
        default: return withDelimiters(2, '.', ',');
      }
    });
    // Comme le filtre Liquid money_without_trailing_zeros : 269,00 → 269
    return amount.replace(/[.,]00(?=\D*$)/, '');
  }

  function initFormula(root) {
    if (!root || root.__plFormulaReady) return;
    root.__plFormulaReady = true;

    var section = root.closest('.atc-product-pl') || document;
    var moneyFormat = root.getAttribute('data-money-format');
    var addonVariantId = Number(root.dataset.addonVariantId);
    var addonPrice = Number(root.dataset.addonPrice) || 0;
    var addonCompare = Number(root.dataset.addonCompare) || addonPrice;
    // Prix barré Virtuoso imposé dans l'éditeur (réglage « Prix barré Virtuoso »), sinon prix couleur + prix barré abonnement.
    var virtuosoCompareOverride = Number(root.dataset.virtuosoCompare) || 0;
    var addonAvailable = root.dataset.addonAvailable === 'true';
    var errorEl = root.querySelector('[data-pl-formula-error]');
    var packMode = root.dataset.plFormulaMode === 'pack';
    var packVariants = {};
    if (packMode) {
      var packData = root.querySelector('[data-pl-formula-variants]');
      try {
        (JSON.parse(packData ? packData.textContent : '[]') || []).forEach(function (v) {
          packVariants[String(v.id)] = v;
        });
      } catch (e) {}
    }
    var colorInputs = Array.prototype.slice.call(
      section.querySelectorAll('[data-variant-options] input[data-variant-id]')
    );
    // Pack piano + couleur (sinon pack à une option, géré comme le Piano LED Plus via les cartes couleur).
    var packDual = packMode && !!section.querySelector('[data-piano-style]');

    colorInputs.forEach(function (input) {
      if (!input.dataset.plBasePrice) input.dataset.plBasePrice = input.dataset.variantPrice;
    });

    function currentFormula() {
      var checked = root.querySelector('.pl-formula__input:checked');
      return checked ? checked.value : 'essentiel';
    }

    function isVirtuoso() {
      return addonAvailable && currentFormula() === 'virtuoso';
    }

    function checkedColor() {
      return section.querySelector('[data-variant-options] input[data-variant-id]:checked') || colorInputs[0];
    }

    // Packs : variante choisie = celle que la section a mise dans son champ caché du formulaire.
    function packVariant() {
      var hidden = section.querySelector('[data-variant-input]');
      return hidden ? packVariants[String(hidden.value)] || null : null;
    }

    function basePrice() {
      if (packMode) {
        var v = packVariant();
        return v ? Number(v.price) || 0 : 0;
      }
      var color = checkedColor();
      return color ? Number(color.dataset.plBasePrice) || 0 : 0;
    }

    function virtuosoCompare(base) {
      return virtuosoCompareOverride || base + addonCompare;
    }

    // Même écriture que le script de la section sur le bouton (« €269,00 »).
    function buttonMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    // Prix barré à côté du prix des boutons « Ajouter au panier » (principal et barre fixe), pour Virtuoso.
    // Élément à part, sans data-compare-price : la protection de prix de la section ne le réécrit pas.
    // Les boutons sont recherchés à chaque fois car leur contenu est remplacé après un ajout au panier.
    function updateButtonCompare() {
      if (packMode) return; // packs : prix barrés gérés par la section (voir ensurePackCompareEls)
      var base = basePrice();
      var compare = base ? virtuosoCompare(base) : 0;
      var show = isVirtuoso() && compare > base + addonPrice;
      section
        .querySelectorAll('.atc-product-pl__button-prices, .atc-product-pl__sticky-button-prices')
        .forEach(function (box) {
          var el = box.querySelector('.pl-formula-btn-compare');
          if (!el) {
            el = document.createElement('span');
            el.className =
              (box.classList.contains('atc-product-pl__sticky-button-prices')
                ? 'atc-product-pl__sticky-button-price-compare'
                : 'atc-product-pl__button-price-compare') + ' pl-formula-btn-compare';
            box.appendChild(el);
          }
          el.hidden = !show;
          if (show) el.textContent = buttonMoney(compare);
        });
    }

    function updateCards() {
      var base = basePrice();
      if (!base) return;
      var essentielEl = root.querySelector('[data-pl-formula-amount="essentiel"]');
      var virtuosoEls = root.querySelectorAll('[data-pl-formula-amount="virtuoso"]');
      var compareEl = root.querySelector('[data-pl-formula-compare]');
      var savingEl = root.querySelector('[data-pl-formula-saving]');
      if (essentielEl) essentielEl.textContent = formatMoney(base, moneyFormat);
      virtuosoEls.forEach(function (el) {
        el.textContent = formatMoney(base + addonPrice, moneyFormat);
      });
      if (compareEl && !packMode) compareEl.textContent = formatMoney(virtuosoCompare(base), moneyFormat);
      if (savingEl && !packMode) savingEl.textContent = formatMoney(virtuosoCompare(base) - base - addonPrice, moneyFormat);
      updateButtonCompare();
    }

    function updateSelectionUI() {
      root.querySelectorAll('.pl-formula__option').forEach(function (option) {
        var input = option.querySelector('.pl-formula__input');
        option.classList.toggle('is-selected', !!(input && input.checked));
      });
      root.dataset.selected = currentFormula();
      var name = isVirtuoso() ? root.dataset.virtuosoName : root.dataset.essentielName;
      section.querySelectorAll('[data-pl-formula-sticky]').forEach(function (el) {
        el.textContent = name || '';
      });
    }

    // Packs : les prix barrés (bouton, barre fixe) doivent exister même si la variante chargée n'en avait pas.
    // Créés avec les attributs de la section pour que sa protection de prix les tienne à jour ensuite.
    function ensurePackCompareEls() {
      [
        ['.atc-product-pl__button-prices', 'atc-product-pl__button-price-compare', 'data-compare-price'],
        ['.atc-product-pl__sticky-button-prices', 'atc-product-pl__sticky-button-price-compare', 'data-sticky-compare-price']
      ].forEach(function (spec) {
        section.querySelectorAll(spec[0]).forEach(function (box) {
          if (box.querySelector('[' + spec[2] + ']')) return;
          var el = document.createElement('span');
          el.className = spec[1];
          el.setAttribute(spec[2], '');
          el.style.display = 'none';
          box.appendChild(el);
        });
      });
    }

    // Prix du pack choisi (+ abonnement pour Virtuoso) et son prix barré.
    function packTotals(v) {
      var price = Number(v.price) || 0;
      var packCompare = Number(v.compare_at_price) > price ? Number(v.compare_at_price) : 0;
      var virtuoso = isVirtuoso();
      return {
        price: price + (virtuoso ? addonPrice : 0),
        compare: virtuoso ? (packCompare || price) + addonCompare : packCompare
      };
    }

    // Pack à une option : la section met le prix (data-variant-price) mais ne touche pas aux prix barrés.
    function applySinglePackCompare() {
      var v = packVariant();
      if (!v) return;
      var t = packTotals(v);
      var show = t.compare > t.price;
      section.querySelectorAll('[data-compare-price], [data-sticky-compare-price]').forEach(function (el) {
        el.style.display = show ? '' : 'none';
        if (show) el.textContent = buttonMoney(t.compare);
      });
      var headerCompare = document.querySelector('[data-header-compare-price]');
      var headerBadge = document.querySelector('.atc-product-pl__header-discount-badge');
      if (headerCompare) {
        headerCompare.style.display = show ? '' : 'none';
        if (show) headerCompare.textContent = buttonMoney(t.compare);
      }
      if (headerBadge) {
        headerBadge.style.display = show ? '' : 'none';
        if (show) headerBadge.textContent = '-' + Math.round(((t.compare - t.price) / t.compare) * 100) + '%';
      }
    }

    // Pack piano + couleur : la section recalcule (méthode enveloppée, voir patchPackSection) quand on relance son choix de piano.
    function reselectPack() {
      var piano = section.querySelector('[data-piano-style]:checked') || section.querySelector('[data-piano-style]');
      if (piano) piano.dispatchEvent(new Event('change', { bubbles: true }));
    }

    if (packMode) {
      ensurePackCompareEls();
      root.__plPackPrices = packTotals;
      patchPackSection();
    }

    function applyPrices() {
      if (packDual) {
        reselectPack();
        return;
      }
      var extra = isVirtuoso() ? addonPrice : 0;
      colorInputs.forEach(function (input) {
        input.dataset.variantPrice = String((Number(input.dataset.plBasePrice) || 0) + extra);
      });
      // Relance le calcul de prix de la section (bouton, en-tête, barre fixe, 3x sans frais).
      var color = checkedColor();
      if (color) color.dispatchEvent(new Event('change', { bubbles: true }));
      if (packMode) applySinglePackCompare();
    }

    function hideError() {
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
    }

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    root.addEventListener('change', function (event) {
      if (!event.target.matches('.pl-formula__input')) return;
      hideError();
      updateSelectionUI();
      applyPrices();
      updateButtonCompare();
    });

    colorInputs.forEach(function (input) {
      input.addEventListener('change', updateCards);
    });

    // Packs : après chaque choix de piano ou de couleur (la section a déjà mis ses prix à jour), cartes et prix barrés.
    if (packMode) {
      section.querySelectorAll('[data-variant-id], [data-piano-style], [data-led-color]').forEach(function (input) {
        input.addEventListener('change', function () {
          updateCards();
          if (!packDual) applySinglePackCompare();
        });
      });
    }

    // Bouton « i » : fiche d'information Virtuoso dans une boîte de dialogue native
    // (Échap ferme, le focus reste dedans, la sélection de formule et de couleur est conservée).
    var infoButton = root.querySelector('[data-pl-formula-info-open]');
    var dialog = root.querySelector('[data-pl-formula-dialog]');
    if (infoButton && dialog) {
      var lockScroll = function (on) {
        document.documentElement.classList.toggle('pl-formula-dialog-open', on);
      };
      // Vidéo explicative : celle qui est affichée (16:9 ou 9:16 selon l'écran) démarre avec le son
      // à l'ouverture (le clic sur « i » l'autorise) ; si le navigateur refuse, elle démarre sans le son.
      var videoBox = dialog.querySelector('[data-pl-formula-video]');
      var visibleVideo = function () {
        if (!videoBox) return null;
        var frames = videoBox.querySelectorAll('.plf-video__frame');
        for (var i = 0; i < frames.length; i++) {
          if (window.getComputedStyle(frames[i]).display !== 'none') return frames[i].querySelector('video');
        }
        return null;
      };
      var playVideo = function () {
        var video = visibleVideo();
        if (!video) return;
        if (video.ended) video.currentTime = 0;
        video.muted = false;
        var playing = video.play();
        if (playing && typeof playing.catch === 'function') {
          playing.catch(function () {
            video.muted = true;
            video.play().catch(function () {});
          });
        }
      };
      var pauseVideos = function () {
        if (!videoBox) return;
        videoBox.querySelectorAll('video').forEach(function (video) {
          if (!video.paused) video.pause();
        });
      };
      infoButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        lockScroll(true);
        var body = dialog.querySelector('.pl-formula-dialog__body');
        if (body) body.scrollTop = 0;
        playVideo();
      });
      // Sur ce thème, l'événement « close » des <dialog> n'arrive pas jusqu'ici : on suit plutôt
      // l'attribut « open », ce qui couvre toutes les façons de fermer (bouton, Échap, fond).
      new MutationObserver(function () {
        lockScroll(dialog.open);
        if (!dialog.open) pauseVideos();
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
      var closeDialog = function () {
        if (dialog.open) dialog.close();
        lockScroll(false);
        pauseVideos();
        infoButton.focus();
      };
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDialog();
        }
      });
      // Clic sur le fond assombri : la cible est la boîte elle-même (son contenu remplit tout l'intérieur).
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog();
      });
      dialog.querySelectorAll('[data-pl-formula-dialog-close]').forEach(function (button) {
        button.addEventListener('click', closeDialog);
      });
      var chooseButton = dialog.querySelector('[data-pl-formula-choose]');
      if (chooseButton) {
        chooseButton.addEventListener('click', function () {
          var virtuosoInput = root.querySelector('.pl-formula__input[value="virtuoso"]');
          if (virtuosoInput && !virtuosoInput.disabled && !virtuosoInput.checked) {
            virtuosoInput.checked = true;
            virtuosoInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          closeDialog();
        });
      }
    }

    // Ajout au panier quand Virtuoso est choisi : écoute en phase de capture pour passer
    // avant le gestionnaire de la section, qui n'ajouterait que la variante couleur.
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('[data-product-form], [data-sticky-form]')) return;
        if (!section.contains(form)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        addBundle(form);
      },
      true
    );

    function setButtonState(button, html, disabled) {
      if (!button) return;
      if (disabled) button.setAttribute('disabled', 'disabled');
      else button.removeAttribute('disabled');
      if (html !== null) button.innerHTML = html;
    }

    function addBundle(form) {
      var button = form.querySelector('button[type="submit"]');
      var originalHTML = button ? button.innerHTML : '';
      var mainVariantId = Number(new FormData(form).get('id'));
      var virtuoso = isVirtuoso();
      if (!mainVariantId || (virtuoso && !addonVariantId)) return;

      hideError();
      setButtonState(button, null, true);

      var sections = [];
      document.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
      );

      var mainProps = {};
      mainProps[MAIN_PROP] = virtuoso ? 'virtuoso' : 'essentiel';
      var fullName = virtuoso ? root.dataset.virtuosoFullName : root.dataset.essentielFullName;
      if (fullName) mainProps[NAME_PROP] = fullName;
      var items = [{ id: mainVariantId, quantity: 1, properties: mainProps }];
      if (virtuoso) {
        // L'abonnement est envoyé en premier pour que le Piano LED Plus apparaisse en haut du panier.
        var addonProps = {};
        addonProps[ADDON_PROP] = String(mainVariantId);
        items.unshift({ id: addonVariantId, quantity: 1, properties: addonProps });
      }
      var body = { items: items };
      if (sections.length) body.sections = sections.join(',');

      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            setButtonState(button, null, false);
            showError(
              virtuoso
                ? "L'abonnement n'a pas pu être ajouté au panier. Choisissez Essentiel ou réessayez dans un instant."
                : "Le Piano LED Plus n'a pas pu être ajouté au panier. Réessayez dans un instant."
            );
            return;
          }
          var data = result.data;
          document.dispatchEvent(
            new CustomEvent('variant:add', { bubbles: true, detail: { variant: data, cart: data } })
          );
          document.dispatchEvent(
            new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: data } })
          );
          setButtonState(button, '<span style="color: white;">✓ AJOUTÉ AU PANIER</span>', false);
          setTimeout(function () {
            setButtonState(button, originalHTML, false);
          }, 2000);
        })
        .catch(function () {
          setButtonState(button, null, false);
          showError("Le panier n'a pas répondu. Vérifiez votre connexion et réessayez.");
        });
    }

    // Appliqué une fois les gestionnaires de la section en place (voir plus bas).
    root.__plFormulaSync = function () {
      updateSelectionUI();
      updateCards();
      if (isVirtuoso() || packMode) applyPrices();
    };
  }

  // Enveloppe la méthode de w-ATC-PRODUCT-PL.js qui calcule le prix d'un pack piano + couleur :
  // si la section contient un choix de formule en mode pack, les variantes reçoivent « prix + abonnement ».
  function patchPackSection() {
    if (typeof ATCProductPL === 'undefined' || !ATCProductPL.prototype) return;
    var proto = ATCProductPL.prototype;
    if (proto.__plFormulaPatched || typeof proto.updatePianoPackVariantSelection !== 'function') return;
    var original = proto.updatePianoPackVariantSelection;
    proto.__plFormulaPatched = true;
    proto.updatePianoPackVariantSelection = function () {
      var formula = this.container && this.container.querySelector('[data-pl-formula][data-pl-formula-mode="pack"]');
      if (formula && formula.__plPackPrices && Array.isArray(this.variants)) {
        this.variants.forEach(function (v) {
          if (v.__plBase === undefined) {
            v.__plBase = v.price;
            v.__plBaseCompare = v.compare_at_price;
          }
          var t = formula.__plPackPrices({ price: v.__plBase, compare_at_price: v.__plBaseCompare });
          v.price = t.price;
          v.compare_at_price = t.compare;
        });
      }
      return original.apply(this, arguments);
    };
  }

  function initAll() {
    document.querySelectorAll('[data-pl-formula]').forEach(function (root) {
      initFormula(root);
      if (root.__plFormulaSync) root.__plFormulaSync();
    });
  }

  // La section crée ses gestionnaires de prix sur DOMContentLoaded. Ce script est « defer » comme elle :
  // il s'exécute avant cet événement (readyState vaut alors « interactive », pas « loading »).
  // On attend donc DOMContentLoaded puis la fin de ses écouteurs (setTimeout), et on resynchronise
  // au « load » par sécurité. Rejouer la synchro est sans effet de bord.
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initAll, 0);
  });
  window.addEventListener('load', initAll);
  if (document.readyState === 'complete') initAll();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pl-formula]');
    if (root) {
      setTimeout(function () {
        initFormula(root);
        if (root.__plFormulaSync) root.__plFormulaSync();
      }, 0);
    }
  });
})();
